import { getEnumeration } from 'enumeration'
import { sexArr } from 'json/customer-options'
export let allLabels = [{
  label: '样本条码号',
  value: 'sampleId'
}, {
  label: localStorage.getItem('focusView') === 'LAB' ? '实验室产品' : '套餐名称',
  value: localStorage.getItem('focusView') === 'LAB' ? 'productName' : 'detectionPackageNames'
}, {
  label: '操作结果',
  value: 'message'
}, {
  label: '原因',
  value: 'reason'
}]
export let DATA_ANALYSISED_LABELS = [{
  label: '样本条码号',
  value: 'sampleId'
}, {
  label: '生产条码号',
  value: 'labCode'
}, {
  label: '实验室产品',
  value: 'productName'
}, {
  label: '操作结果',
  value: 'message'
}, {
  label: '原因',
  value: 'reason'
}]
// , {
//   label: '套餐名称',
//   value: 'detectionPackageNames'
// }
export let LAB_SAMPLES_RECEIVED_LABELS = [{
  label: '样本条码号',
  value: 'sampleId'
}, {
  label: '生产条码号',
  value: 'labCode'
}, {
  label: '姓名',
  value: 'patientName'
}, {
  label: '性别',
  value: 'patientGender'
}, {
  label: '样本类型',
  value: 'sampleTypeChineseName'
}, {
  label: '实验室产品',
  value: 'productName'
}, {
  label: '实验室检测平台',
  value: 'sequencingTechnologyType'
}, {
  label: '操作结果',
  value: 'message'
}, {
  label: '原因',
  value: 'reason'
}]
export function getCurrentLables (isShowReason, status) {
  let labels = allLabels
  if (status === '样本接收' || status === '样本提取') {
    labels = LAB_SAMPLES_RECEIVED_LABELS
  }
  if (status === '上传数据') {
    labels = DATA_ANALYSISED_LABELS
  }
  if (!isShowReason) {
    return labels.slice(0, labels.length - 1)
  }
  return labels
}
export function handleData (data) {
  let res = JSON.parse(JSON.stringify(data))
  res.forEach(ele => {
    ele.patientGender = getEnumeration(ele.patientGender, sexArr)
  })
  return res
}
